(function () {
      'use strict';

      var shell = document.getElementById('MMGiftPresentation');
      var template = document.getElementById('MMGiftPresentationTemplate');
      if (!shell || !template) return;

      var variantId = Number(shell.dataset.variantId);
      var price = shell.dataset.price;
      var endpoints = {
        add: shell.dataset.addUrl,
        update: shell.dataset.updateUrl,
        cart: shell.dataset.cartUrl
      };
      var sections = ['cart-icon-bubble'];
      var NOTE_KEY = 'Gift note';
      var PRESENTATION_KEY = 'Gift presentation';
      var NOTE_LIMIT = 180;
      var saveTimer = null;
      var refreshTimer = null;
      var observerPaused = false;
      var mountIndex = 0;

      var state = {
        selected: false,
        note: '',
        giftLine: null,
        busy: false,
        dirty: false,
        error: ''
      };

      function request(url, payload) {
        var options = {
          method: payload ? 'POST' : 'GET',
          credentials: 'same-origin',
          headers: payload ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' }
        };
        if (payload) options.body = JSON.stringify(payload);

        return fetch(url, options).then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        });
      }

      function publishGiftSignal() {
        try {
          if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return;
          window.Shopify.analytics.publish('mm:gift_configured', {
            gift_wrap_selected: state.selected,
            gift_note_added: Boolean(state.note.trim())
          });
        } catch (error) {}
      }

      function cartTargets() {
        return [
          document.querySelector('#CartDrawer .drawer__footer'),
          document.querySelector('.cart-notification__links'),
          document.querySelector('#main-cart-footer .cart__blocks') || document.querySelector('#main-cart-footer .cart__footer > div')
        ].filter(Boolean);
      }

      function mount() {
        cartTargets().forEach(function (target) {
          if (target.querySelector('.mm-gift-presentation')) return;
          var fragment = template.content.cloneNode(true);
          var card = fragment.querySelector('.mm-gift-presentation');
          if (target.classList.contains('cart-notification__links')) {
            card.classList.add('mm-gift-presentation--notification');
          }
          var suffix = String(++mountIndex);
          var title = card.querySelector('#MMGiftTitle');
          var toggle = card.querySelector('[data-mm-gift-toggle]');
          var noteWrap = card.querySelector('[data-mm-gift-note-wrap]');
          var note = card.querySelector('[data-mm-gift-note]');
          var noteLabel = card.querySelector("label[for='MMGiftNote']");
          title.id = 'MMGiftTitle-' + suffix;
          noteWrap.id = 'MMGiftNoteFields-' + suffix;
          note.id = 'MMGiftNote-' + suffix;
          noteLabel.setAttribute('for', note.id);
          toggle.setAttribute('aria-controls', noteWrap.id);
          card.setAttribute('aria-labelledby', title.id);
          card.querySelector('[data-mm-gift-price]').textContent = '+ ' + price;
          target.insertBefore(fragment, target.firstChild);
          bind(card);
        });
        markServiceLines();
        render();
      }

      function markServiceLines() {
        document.querySelectorAll("a[href*='/products/molten-majesty-gift-presentation']").forEach(function (link) {
          var line = link.closest('.cart-item');
          if (line) line.classList.add('mm-gift-service-line');
        });
      }

      function bind(card) {
        var toggle = card.querySelector('[data-mm-gift-toggle]');
        var note = card.querySelector('[data-mm-gift-note]');

        toggle.addEventListener('click', function () {
          if (state.busy) return;
          setSelected(!state.selected);
        });

        note.addEventListener('input', function () {
          state.note = note.value.slice(0, NOTE_LIMIT);
          state.dirty = true;
          render(true);
          window.clearTimeout(saveTimer);
          saveTimer = window.setTimeout(saveNote, 650);
        });

        note.addEventListener('blur', function () {
          if (state.dirty) saveNote();
        });
      }

      function render(preserveFocus) {
        document.querySelectorAll('.mm-gift-presentation').forEach(function (card) {
          var toggle = card.querySelector('[data-mm-gift-toggle]');
          var noteWrap = card.querySelector('[data-mm-gift-note-wrap]');
          var note = card.querySelector('[data-mm-gift-note]');
          var count = card.querySelector('[data-mm-gift-count]');
          var status = card.querySelector('[data-mm-gift-status]');
          var activeNote = preserveFocus && document.activeElement === note;

          toggle.setAttribute('aria-checked', state.selected ? 'true' : 'false');
          toggle.disabled = state.busy;
          noteWrap.hidden = !state.selected;
          if (!activeNote && note.value !== state.note) note.value = state.note;
          count.textContent = String(state.note.length);
          status.textContent = state.error;
        });
      }

      function attributes() {
        var result = {};
        result[PRESENTATION_KEY] = state.selected ? 'Yes' : '';
        result[NOTE_KEY] = state.selected ? state.note.trim() : '';
        return result;
      }

      function bundledPayload(extra) {
        var payload = extra || {};
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
        return payload;
      }

      function replaceSection(id, html, selector) {
        var current = document.querySelector(selector);
        if (!current || !html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector(selector);
        if (!fresh) return;
        current.innerHTML = fresh.innerHTML;
      }

      function updateCartBadge(cart) {
        var bubble = document.querySelector('#cart-icon-bubble');
        if (!cart || !Array.isArray(cart.items)) return;

        var count = cart.items.reduce(function (total, item) {
          return Number(item.variant_id) === variantId ? total : total + Number(item.quantity || 0);
        }, 0);
        var notificationButton = document.querySelector('#cart-notification-button');
        if (notificationButton && /\(\d+\)/.test(notificationButton.textContent || '')) {
          notificationButton.textContent = notificationButton.textContent.replace(/\(\d+\)/, '(' + count + ')');
        }
        if (!bubble) return;
        var countBubble = bubble.querySelector('.cart-count-bubble');

        if (count < 1) {
          if (countBubble) countBubble.remove();
          return;
        }

        if (!countBubble) {
          countBubble = document.createElement('div');
          countBubble.className = 'cart-count-bubble';
          countBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          bubble.appendChild(countBubble);
        }

        var visible = countBubble.querySelector("span[aria-hidden='true']");
        var accessible = countBubble.querySelector('.visually-hidden');
        if (visible) visible.textContent = String(count);
        if (accessible) accessible.textContent = count === 1 ? '1 item' : count + ' items';
      }

      function updateDisplayedTotals(cart) {
        if (!cart || typeof cart.total_price !== 'number') return;
        var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'USD';
        var formatted;

        try {
          formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: currency
          }).format(cart.total_price / 100);
        } catch (error) {
          formatted = (cart.total_price / 100).toFixed(2) + ' ' + currency;
        }

        document.querySelectorAll('#main-cart-footer .totals__row').forEach(function (row) {
          var label = row.querySelector('.totals__label');
          var value = row.querySelector('.totals__value');
          if (!value) return;

          if (value.classList.contains('totals__total-value')) {
            value.textContent = formatted + ' ' + currency;
          } else if (label && label.textContent.trim().toLowerCase() === 'subtotal') {
            value.textContent = formatted;
          }
        });
      }

      function refreshSections(rendered) {
        if (!rendered) return;
        observerPaused = true;
        replaceSection('cart-drawer', rendered['cart-drawer'], '#CartDrawer');
        replaceSection('cart-icon-bubble', rendered['cart-icon-bubble'], '#cart-icon-bubble');
        replaceSection('main-cart-items', rendered['main-cart-items'], '#main-cart-items');
        replaceSection('main-cart-footer', rendered['main-cart-footer'], '#main-cart-footer');
        window.setTimeout(function () {
          observerPaused = false;
          mount();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 30);
      }

      function applyCart(cart) {
        state.giftLine = (cart.items || []).find(function (item) { return Number(item.variant_id) === variantId; }) || null;
        state.selected = Boolean(state.giftLine);
        state.note = state.selected && cart.attributes ? String(cart.attributes[NOTE_KEY] || '').slice(0, NOTE_LIMIT) : '';
        state.dirty = false;
        state.error = '';
        mount();
        updateCartBadge(cart);
        updateDisplayedTotals(cart);

        var merchandise = (cart.items || []).filter(function (item) { return Number(item.variant_id) !== variantId; });
        if (state.giftLine && merchandise.length === 0 && !state.busy) removeGift(true);
      }

      function syncFromCart() {
        if (state.busy) return Promise.resolve();
        return request(endpoints.cart).then(applyCart).catch(function () {});
      }

      function setSelected(next) {
        state.busy = true;
        state.error = '';
        render();
        if (next) addGift();
        else removeGift(false);
      }

      function addGift() {
        request(endpoints.add, {
          items: [{ id: variantId, quantity: 1, properties: { _mm_gift_service: 'true' } }]
        }).then(function () {
          state.selected = true;
          return request(endpoints.update, bundledPayload({ attributes: attributes() }));
        }).then(function (cart) {
          state.busy = false;
          state.giftLine = (cart.items || []).find(function (item) { return Number(item.variant_id) === variantId; }) || null;
          state.selected = Boolean(state.giftLine);
          state.dirty = false;
          publishGiftSignal();
          refreshSections(cart.sections);
          updateCartBadge(cart);
          updateDisplayedTotals(cart);
          render();
        }).catch(handleError);
      }

      function removeGift(quiet) {
        var updates = {};
        if (state.giftLine && state.giftLine.key) updates[state.giftLine.key] = 0;
        else updates[String(variantId)] = 0;

        state.busy = true;
        state.note = '';
        state.selected = false;
        state.dirty = false;
        render();

        request(endpoints.update, bundledPayload({ updates: updates, attributes: attributes() })).then(function (cart) {
          state.busy = false;
          state.giftLine = null;
          if (!quiet) publishGiftSignal();
          refreshSections(cart.sections);
          updateCartBadge(cart);
          updateDisplayedTotals(cart);
          render();
        }).catch(handleError);
      }

      function saveNote() {
        window.clearTimeout(saveTimer);
        if (!state.selected || !state.dirty || state.busy) return Promise.resolve();
        state.dirty = false;
        return request(endpoints.update, { attributes: attributes() }).then(function () {
          state.error = '';
          publishGiftSignal();
          render(true);
        }).catch(function () {
          state.dirty = true;
          state.error = 'Your note could not be saved. Please try again.';
          render(true);
        });
      }

      function handleError() {
        state.busy = false;
        state.error = 'We could not update your gift presentation. Please try again.';
        syncFromCart().finally(function () { render(); });
      }

      function scheduleRefresh() {
        if (observerPaused || state.busy) return;
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(syncFromCart, 260);
      }

      var observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          return target && !target.closest('.mm-gift-presentation') && (
            target.closest('#CartDrawer') || target.closest('cart-notification') || target.closest('#main-cart-items') || target.closest('#main-cart-footer') || target.id === 'cart-icon-bubble'
          );
        });
        if (relevant) scheduleRefresh();
      });

      document.addEventListener('click', function (event) {
        var checkout = event.target.closest("button[name='checkout'], .cart__checkout-button, a[href*='/checkout']");
        if (!checkout || !state.selected || !state.dirty) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        saveNote().finally(function () {
          if (checkout.tagName === 'A' && checkout.href) {
            window.location.assign(checkout.href);
          } else if (checkout.form) {
            var field = document.createElement('input');
            field.type = 'hidden';
            field.name = checkout.name || 'checkout';
            field.value = checkout.value || 'Checkout';
            checkout.form.appendChild(field);
            checkout.form.submit();
          } else {
            window.location.assign('/checkout');
          }
        });
      }, true);

      window.setInterval(function () {
        var needsMount = cartTargets().some(function (target) {
          return !target.querySelector('.mm-gift-presentation');
        });
        if (needsMount) mount();
      }, 700);

      observer.observe(document.body, { childList: true, subtree: true });
      window.MMGiftPresentation = { refresh: syncFromCart };
      syncFromCart();
    })();